export const environment = {
  production: false,
  apiUrl: 'https://api.lhiis.net/api/v1/',
  // Versión de la app que se manda con cada reporte de bug: sin ella no se puede saber si un
  // fallo ya estaba arreglado en una versión posterior a la que tenía cargada quien lo reportó.
  // Se mantiene a mano junto al "version" de package.json — importarlo lo metería en el bundle
  // del cliente, exponiendo el árbol de dependencias.
  appVersion: '2.10.0',
  // Build dev/QA: el canal digital sigue siendo prod. Si en el futuro existe
  // un canal QA separado, cambiar este valor. Riesgo controlado: backend QA
  // ignora referrers no existentes (log [REFERRAL-INVALID]) sin bloquear el alta.
  clientAppUrl: 'https://rendafin.com'
}
